import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Alert } from '@mantine/core';
import type { ReactNode } from 'react';

import { Icon } from '../Spinner/Icon';
import type { AlertProps } from './AlertProps';

const AlertIcon = <Icon icon={faCircleExclamation} />;

export function InfoAlert(props: AlertProps): ReactNode {
	const icon = props.icon ?? AlertIcon;

	return (
		<Alert c={'blue.9'} bg={'blue.1'} variant="light" title={props.title} icon={icon}>
			{props.children}
		</Alert>
	);
}
